import { styled } from '@mui/material'

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;

  & * {
    font-family: Inter, Roboto;
  }

  .react-datepicker__header {
    background: #ffffff;
    padding: 16px 16px;
    border: 0;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
  }

  .react-datepicker__day-names {
    justify-content: space-between;
  }

  .react-datepicker__day-name {
    width: auto;
  }

  .react-datepicker__day {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-radius: 0;
  }

  .react-datepicker__day:hover {
    background-color: rgba(1, 247, 194, 0.2);
    color: #000000;
    border-radius: 0;
  }

  .react-datepicker__day--in-selecting-range.react-datepicker__day:hover {
    background: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--in-selecting-range {
    background: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--in-range {
    background: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--range-end {
    background: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--range-end:hover,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__day--in-selecting-range:hover {
    background: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 0;
    background-color: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__day--keyboard-selected:hover {
    background-color: #01f7c2 !important;
    color: #000000;
  }

  .react-datepicker__children-container {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`

export const HeaderWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  font-size: 14px;

  button {
    border-radius: 5px;
    cursor: pointer;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`

export const Footer = styled('div')`
  display: flex;
  align-items: center;
  width: 200px;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
`
